import React, { useState, useEffect } from 'react';
import './newCustomerDialog.css';
import { getCookie } from './utils/cookies'; // If you use token via cookies
import { authFetchRequest } from './utils/api'; // ✅ Use your API utils


const EditSupplierDialog = ({ show, onClose, data, onSave }) => {
    const [supplier, setSupplier] = useState({
        name: '',
        email: '',
        phone: '',
        discount: '',
        products: '',
        netTerms: '',
        fullName: '',
        mobilePhone: '',
        address1: '',
        address2: '',
        city: '',
        province: '',
        country: '',
        postalCode: '',
    });

    useEffect(() => {
        if (data) {
            setSupplier(data);
        }
    }, [data]);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setSupplier((prev) => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
      
        if (!supplier?.id) {
          console.error('Supplier ID is undefined or invalid. Cannot proceed.');
          return;
        }
      
        try {
          const updatedSupplier = await authFetchRequest(
            `/suppliers/${supplier.id}`,
            supplier,
            'PUT',
            {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${getCookie('access_token')}`,
            }
          );
      
          onSave(updatedSupplier);
          onClose();
        } catch (error) {
          console.error('Error updating supplier:', error);
        }
      };

    if (!show) return null;

    return (
        <div className="modal-overlay" onClick={onClose}>
            <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                <h2>Edit Supplier</h2>
                <form onSubmit={handleSubmit}>
                    <div className="form-group-dialog">
                        <input type="text" name="name" value={supplier.name} onChange={handleInputChange} placeholder="Supplier Name" required />
                    </div>
                    <div className="form-group-dialog">
                        <input type="email" name="email" value={supplier.email} onChange={handleInputChange} placeholder="Email" />
                    </div>
                    <div className="form-group-dialog">
                        <input type="tel" name="phone" value={supplier.phone} onChange={handleInputChange} placeholder="Phone" />
                    </div>
                    <div className="form-group-dialog">
                        <input type="text" name="discount" value={supplier.discount} onChange={handleInputChange} placeholder="Discount" />
                    </div>
                    <div className="form-group-dialog">
                        <input type="text" name="products" value={supplier.products} onChange={handleInputChange} placeholder="Selectable Products (Optional)" />
                    </div>
                    <div className="form-group-dialog">
                        <input type="text" name="netTerms" value={supplier.netTerms} onChange={handleInputChange} placeholder="NET Terms" />
                    </div>
                    <div className="customer-details">
                        <h3>Supplier Details</h3>
                        <input type="text" name="fullName" value={supplier.fullName} onChange={handleInputChange} placeholder="Full Name" />
                        <input type="tel" name="mobilePhone" value={supplier.mobilePhone} onChange={handleInputChange} placeholder="Mobile Phone" />
                    </div>
                    <div className="customer-address">
                        <h3>Supplier Address</h3>
                        <input type="text" name="address1" value={supplier.address1} onChange={handleInputChange} placeholder="Address 1" />
                        <input type="text" name="address2" value={supplier.address2} onChange={handleInputChange} placeholder="Address 2" />
                        <input type="text" name="city" value={supplier.city} onChange={handleInputChange} placeholder="City" />
                        <input type="text" name="province" value={supplier.province} onChange={handleInputChange} placeholder="Province" />
                        <input type="text" name="country" value={supplier.country} onChange={handleInputChange} placeholder="Country" />
                        <input type="text" name="postalCode" value={supplier.postalCode} onChange={handleInputChange} placeholder="Postal Code" />
                    </div>
                    <div className="form-actions">
                        <button type="button" onClick={onClose}>Close</button>
                        <button type="submit">Save</button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default EditSupplierDialog;
